<template src='./project-lists.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage
  },
  props: ['project'],
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      updatedCode: this.$route.query.updatedCode,
      pageLoader: false,
      currentProject: { ProjectId: this.project.id, ProjectCode: this.project.code, OriginalProject: false },
      projectListIds: []
    }
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
    if (this.project.ideaList) {
      this.projectListIds.push(3)
    }

    if (this.project.identificationList) {
      this.projectListIds.push(4)
    }

    if (this.project.preparednessList) {
      this.projectListIds.push(5)
    }
  },
  methods: {
    saveSettings () {
      this.showLoader(true)
      this.pageLoader = true
      var listRequestParm = {
        projects: [this.currentProject],
        projectListIds: this.projectListIds
      }
      this.$http.put(Vue.$apiConfig.projectSendToListPut, listRequestParm).then(
        response => {
          this.logConsole(response)
          EventBus.$emit('alert', {
            variant: 'success',
            message: this.$t('projects.updateProjectSuccessful'),
            errors: []
          })
          this.showLoader(false)
          this.pageLoader = false
        },
        error => {
          this.formatErrorResponse(error)
          this.showLoader(false)
          this.pageLoader = false
        })
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
